import { render, staticRenderFns } from "./MovieFeedPage.vue?vue&type=template&id=6d28df14&scoped=true&"
import script from "./MovieFeedPage.vue?vue&type=script&lang=js&"
export * from "./MovieFeedPage.vue?vue&type=script&lang=js&"
import style0 from "./MovieFeedPage.vue?vue&type=style&index=0&id=6d28df14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28df14",
  null
  
)

export default component.exports